import React from 'react';

import {WillAnimate} from '../../components/content_animate';
import {Layout} from '../../components/layout';
import {NumberHero} from '../../components/number_hero';
import {ScrollTo} from '../../components/scroll_to';

const locale = 'en';

export default ({data}: any) => {
    return (
        <Layout
            title="A specialized team of software engineers who developed software for entrepreneurs."
            ogImage="homepage-en.png"
            locale={locale}
            translatedPagePath="/">
            <WillAnimate as="div" name="hero" className="hero--home" id="hero">
                <div className="hero__content-wrapper">
                    <div className="hero__content">
                        <h1>
                            We <br />
                            <span className="highlight">were</span> <br />
                            Label305
                        </h1>
                        <h2>
                            Since 2010, we developed user-friendly software <br />
                            and made complex processes simple.
                        </h2>
                    </div>
                </div>
                <ScrollTo className="hero__scroll" target="/en/#from-hero" position="start" />

                <NumberHero />
            </WillAnimate>

            <section className="section">
                <WillAnimate id="from-hero">
                    <div className="container">
                        <div className="content__display">
                            <h2>
                                15 years <br />
                                software
                                <br /> consultancy
                            </h2>
                        </div>
                        <div className="content__copy">
                            <p className="p-lead">
                                As of <strong>June 1, 2025</strong>, we have{' '}
                                <strong className="highlight">ceased</strong> the services of Label305.
                            </p>
                            <p>We look back with pride on 15 years of software consultancy with a great team.</p>
                            <p>
                                From web platforms to apps, from sports and automotive to valuation: Label305 was the{' '}
                                consultancy for entrepreneurs.
                            </p>
                            <p>
                                The user always came first: we simplified complex processes, paid a lot of attention to{' '}
                                the user experience, and created software that is easy to use.
                            </p>
                            <p>
                                From a small team, located on the campus of the University of Twente, we grew to a team{' '}
                                of 22 specialists with an office in both Amsterdam and Enschede. In 2021 we scaled back{' '}
                                to a small and close-knit team located at the Hengelosestraat.
                            </p>
                            <p>
                                We look back on a fantastic time and thank everyone who helped us or with whom we
                                collaborated.
                            </p>
                        </div>
                    </div>
                </WillAnimate>
            </section>
        </Layout>
    );
};
